'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var useItemScroll = function (active) {
    var ref = React.useRef(null);
    React.useEffect(function () {
        var _a;
        if (active && ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.parentNode)) {
            ref.current.parentNode.scrollTo({
                top: ref.current.offsetTop,
                behavior: 'smooth',
            });
        }
    }, [active]);
    return ref;
};

var Container = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  min-width: 55px;\n  padding-left: 12px;\n  font-size: 14px;\n  line-height: ", ";\n  color: ", ";\n  cursor: pointer;\n\n  &:hover:not(.active) {\n    background-color: ", ";\n  }\n\n  &.active {\n    font-weight:700;\n    color: ", ";\n    background-color: ", ";\n  }\n\n  ", "\n"], ["\n  min-width: 55px;\n  padding-left: 12px;\n  font-size: 14px;\n  line-height: ", ";\n  color: ", ";\n  cursor: pointer;\n\n  &:hover:not(.active) {\n    background-color: ", ";\n  }\n\n  &.active {\n    font-weight:700;\n    color: ", ";\n    background-color: ", ";\n  }\n\n  ",
    "\n"])), function (_a) {
    var valueHeight = _a.valueHeight;
    return valueHeight + "px";
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.sharedDarkGrey;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyLight;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyLight;
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    opacity: 0.5;\n    cursor: not-allowed;\n  "], ["\n    opacity: 0.5;\n    cursor: not-allowed;\n  "])));
});
var Value = function (_a) {
    var value = _a.value, active = _a.active, disabled = _a.disabled, onClick = _a.onClick, valueHeight = _a.valueHeight, dataTestId = _a.dataTestId, dataCy = _a.dataCy;
    var ref = useItemScroll(active);
    var handleClick = React.useCallback(function () {
        if (!disabled) {
            onClick(value);
        }
    }, [onClick, value, disabled]);
    return (React__default.createElement(Container, { ref: ref, className: active ? 'active' : '', onClick: handleClick, valueHeight: valueHeight, disabled: disabled, "data-testid": dataTestId + "-" + value + "-item", "data-cy": dataCy + "-" + value + "-item" }, value));
};
var templateObject_1, templateObject_2;

var Container$1 = styled__default.div(templateObject_1$1 || (templateObject_1$1 = tslib_es6.__makeTemplateObject(["\n  height: ", ";\n  font-family: ", ";\n  border-right: ", ";\n  overflow-y: scroll;\n  ::-webkit-scrollbar {\n    display: none;\n  }\n\n  &:last-child {\n    border-right: none;\n  }\n"], ["\n  height: ", ";\n  font-family: ", ";\n  border-right: ", ";\n  overflow-y: scroll;\n  ::-webkit-scrollbar {\n    display: none;\n  }\n\n  &:last-child {\n    border-right: none;\n  }\n"])), function (_a) {
    var valueHeight = _a.valueHeight, maxVisible = _a.maxVisible;
    return valueHeight * maxVisible + "px";
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.sharedMediumGrey + " solid 1px";
});
var ScrollSpace = styled__default.div(templateObject_2$1 || (templateObject_2$1 = tslib_es6.__makeTemplateObject(["\n  width: 100%;\n  height: ", ";\n"], ["\n  width: 100%;\n  height: ", ";\n"])), function (_a) {
    var valueHeight = _a.valueHeight, maxVisible = _a.maxVisible;
    return valueHeight * (maxVisible - 1) + "px";
});
var Values = function (_a) {
    var className = _a.className, values = _a.values, activeValue = _a.activeValue, onClick = _a.onClick, valueHeight = _a.valueHeight, maxVisible = _a.maxVisible, dataTestId = _a.dataTestId, dataCy = _a.dataCy;
    return (React__default.createElement(Container$1, { className: className, valueHeight: valueHeight, maxVisible: maxVisible, "data-testid": dataTestId, "data-cy": dataCy },
        values.map(function (_a) {
            var value = _a.value, disabled = _a.disabled;
            return (React__default.createElement(Value, { key: value, active: value === activeValue, onClick: onClick, value: value, disabled: disabled, valueHeight: valueHeight, dataTestId: dataTestId, dataCy: dataCy }));
        }),
        React__default.createElement(ScrollSpace, { "data-testid": "scroll-space", valueHeight: valueHeight, maxVisible: maxVisible })));
};
var templateObject_1$1, templateObject_2$1;

var generateTimePartString = function (value) { return value.toString().padStart(2, '0'); };

var useTimeValues = function (date, is12h) {
    var _a = tslib_es6.__read(date.split(':'), 2), hoursString = _a[0], minutesString = _a[1];
    var hours = is12h ? parseInt(hoursString, 10) % 12 || 12 : parseInt(hoursString, 10);
    var minutes = parseInt(minutesString, 10);
    return {
        hours: parseInt(hoursString, 10),
        formattedHours: hours.toString().padStart(2, '0'),
        minutes: minutes.toString().padStart(2, '0'),
        amPm: parseInt(hoursString, 10) >= 12 ? 'pm' : 'am',
    };
};

exports.Values = Values;
exports.generateTimePartString = generateTimePartString;
exports.useItemScroll = useItemScroll;
exports.useTimeValues = useTimeValues;
